import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "defaultChecked", "boxDummyClassName"];
import React from "react";
var __jsx = React.createElement;
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from "@i18n";
import stl from './RHFCheckbox.module.css';
import { useState } from "react";
var RHFCheckbox = function RHFCheckbox(_ref) {
  var name = _ref.name,
    _ref$defaultChecked = _ref.defaultChecked,
    defaultChecked = _ref$defaultChecked === void 0 ? true : _ref$defaultChecked,
    boxDummyClassName = _ref.boxDummyClassName,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(defaultChecked),
    checked = _useState[0],
    setChecked = _useState[1];
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({
        className: stl.checkbox,
        type: "checkbox",
        defaultChecked: defaultChecked,
        checked: field.value,
        onChange: function onChange(e) {
          field.onChange(e.target.checked);
          setChecked(e.target.checked);
        }
      }, field, other)), /*#__PURE__*/React.createElement("span", {
        className: [stl.boxDummy, boxDummyClassName].join(" ")
      }), error && /*#__PURE__*/React.createElement("span", {
        className: "errorText"
      }, tShort(error.message, {
        ns: "validations"
      })));
    }
  });
};
export default RHFCheckbox;